var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportHeadphone = function SvgSupportHeadphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#supportHeadphone_svg__a)",
    rx: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#supportHeadphone_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.91 8.4a8.49 8.49 0 0 0-5.97-2.51c-2.22 0-4.4.92-5.96 2.51-1.38 1.4-2.13 3.16-2.12 4.97.02 1.33.06 2.68.14 4.01.02.4.35.71.75.71h.04c.41-.02.73-.38.71-.79-.07-1.31-.12-2.64-.13-3.95-.01-1.4.58-2.79 1.68-3.9 1.29-1.3 3.07-2.06 4.89-2.06 1.83 0 3.61.76 4.9 2.06 1.1 1.11 1.7 2.5 1.68 3.89-.02 1.29-.06 2.61-.13 3.92a.75.75 0 1 0 1.5.08c.07-1.33.12-2.67.13-3.99.02-1.8-.73-3.57-2.12-4.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 13.9c-.61 0-1.1.49-1.1 1.1v4c0 .61.49 1.1 1.1 1.1s1.1-.49 1.1-1.1v-4c0-.61-.49-1.1-1.1-1.1M21.88 19v-4c0-.61-.49-1.1-1.1-1.1s-1.1.49-1.1 1.1v4c0 .61.49 1.1 1.1 1.1s1.1-.49 1.1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.15 18.57c-.28 0-.5.22-.5.5v2.07c0 1.8-1.84 3.26-4.11 3.26h-.23a.99.99 0 0 0-.85-.5H16c-.55 0-1 .45-1 1s.45 1 1 1h1.46c.37 0 .67-.21.85-.5h.23c2.82 0 5.11-1.91 5.11-4.26v-2.07c0-.28-.22-.5-.5-.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "supportHeadphone_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.995 14.33 7.47)scale(39.6228 36.7569)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "supportHeadphone_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h24v24H4z"
  })))));
};
export default SvgSupportHeadphone;